module.exports = __webpack_public_path__ + "static/img/tenor.aa5f34f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tenor.gif
// module id = 1617
// module chunks = 3 5 6 9 10